import NiceModal from '@ebay/nice-modal-react';

import { useRef, useState } from 'react';

import Button from 'components/field/Button';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import MinimizedShipmentButton from './Components/MinimizedShipmentButton';
import CreateShipmentWithMyRatesForm from './CreateShipmentWithMyRatesForm';

const CreateShipmentWithMyRatesModal = NiceModal.create(({ ids, mode, modalName, lastIndexOfErrorLogs }) => {
	const formRef = useRef();
	const [isAllShipmentsCreated, setIsAllShipmentsCreated] = useState(false);
	const [loading, setLoading] = useState(true);
	const [successCount, setSuccessCount] = useState(0);
	const [failedCount, setFailedCount] = useState(0);
	const [totalCount, setTotalCount] = useState(0);

	return (
		<Modal
			minimizeButton={(show, close) => (
				<MinimizedShipmentButton
					label="createShipmentWithMyRates"
					onShow={show}
					onClose={close}
					successCount={successCount}
					failedCount={failedCount}
					totalCount={totalCount}
				/>
			)}
			maxWidth="xx-large"
			fullwidth
			name={modalName}
			className="modal-withMyRates">
			<ModalTitle>
				<Typography variant="p1">
					{mode === 'automaticShipment' ? 'createShipmentAutomatically.title' : 'createShipmentWithMyRates'}
				</Typography>
			</ModalTitle>
			<ModalContent>
				<CreateShipmentWithMyRatesForm
					ref={formRef}
					ids={ids}
					setIsAllShipmentsCreated={setIsAllShipmentsCreated}
					setLoading={setLoading}
					setSuccessCount={setSuccessCount}
					setFailedCount={setFailedCount}
					setTotalCount={setTotalCount}
					automaticShipmentMode={mode === 'automaticShipment'}
					defaultLastIndexOfErrorLogs={lastIndexOfErrorLogs}
				/>
			</ModalContent>
			<ModalActions>
				{isAllShipmentsCreated ? (
					<Button label="printAwb" onClick={formRef.current?.handlePrintAWB} loading={loading} />
				) : (
					<Button label="createShipment" onClick={formRef.current?.handleCreateShipment} loading={loading} />
				)}
			</ModalActions>
		</Modal>
	);
});

export default CreateShipmentWithMyRatesModal;
